import { render, staticRenderFns } from "./MemberAge.vue?vue&type=template&id=4d86bafc&scoped=true"
import script from "./MemberAge.vue?vue&type=script&lang=js"
export * from "./MemberAge.vue?vue&type=script&lang=js"
import style0 from "./MemberAge.vue?vue&type=style&index=0&id=4d86bafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86bafc",
  null
  
)

export default component.exports